import { useNavigate, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';

function SymptomsIndex() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [tghNews, setTghNews] = useState([]);
  const [newsLoading, setNewsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setNewsLoading(true);
        const response = await axios.get('/api/news');
        const news = Array.isArray(response.data)
          ? response.data
          : response.data?.news || [];
        news.sort((a, b) => new Date(b.date) - new Date(a.date));
        if (!cancelled) setTghNews(news);
      } catch (e) {
        console.error('Error fetching news:', e);
        if (!cancelled) setTghNews([]);
      } finally {
        if (!cancelled) setNewsLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return null;
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  const handleLetterClick = (letter) => {
    navigate(`/symptoms/${letter}`);
    window.scrollTo(0, 0);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const q = searchQuery.trim();
    if (!q) return;
    const first = q.charAt(0).toUpperCase();
    const l = /[A-Z]/.test(first) ? first : '#';
    navigate(`/symptoms/${l}?search=${encodeURIComponent(q)}`);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <section className="py-5" style={{ backgroundColor: '#fff', color: '#333', minHeight: '400px' }}>
        <div className="container">
          <nav aria-label="breadcrumb" className="mb-3">
            <ol className="breadcrumb" style={{ backgroundColor: 'transparent', padding: 0 }}>
              <li className="breadcrumb-item"><Link to="/" style={{ color: 'var(--tgh-blue-light)' }}>Home</Link></li>
              <li className="breadcrumb-item active" style={{ color: '#666' }}>Symptoms</li>
            </ol>
          </nav>

          <h1 className="display-4 mb-3" style={{ fontFamily: 'Lora, serif', fontWeight: 'bold', color: 'var(--tgh-blue)' }}>
            Symptoms
          </h1>
          <p className="lead mb-5" style={{ fontSize: '1.1rem', color: '#666' }}>
            Browse symptoms from our diseases and conditions articles. Selecting a symptom shows related conditions.
          </p>
          <p className="tgh-diseases-disclaimer mb-4" role="note">
            This is for informational purposes only. For medical advice or a diagnosis, consult a professional or
            healthcare provider.
          </p>

          <div className="row mt-4">
            <div className="col-lg-6">
              <label className="mb-2" style={{ fontSize: '0.95rem', fontWeight: '600', color: '#333' }}>
                Search symptoms
              </label>
              <form onSubmit={handleSearch}>
                <div className="input-group input-group-lg">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{ borderRadius: '8px 0 0 8px', border: '1px solid #ddd' }}
                  />
                  <button className="btn btn-primary" type="submit" style={{ borderRadius: '0 8px 8px 0', backgroundColor: 'var(--tgh-blue)', borderColor: 'var(--tgh-blue)' }}>
                    <i className="bi bi-search"></i>
                  </button>
                </div>
              </form>
            </div>
            <div className="col-lg-6">
              <label className="mb-2" style={{ fontSize: '0.95rem', fontWeight: '600', color: '#333' }}>
                Find symptoms by first letter
              </label>
              <div className="d-flex flex-wrap gap-2">
                {alphabet.map((ltr) => (
                  <button
                    key={ltr}
                    type="button"
                    className="btn btn-outline-primary"
                    onClick={() => handleLetterClick(ltr)}
                    style={{
                      width: '45px',
                      height: '45px',
                      borderRadius: '50%',
                      fontWeight: '600',
                      border: '2px solid var(--tgh-blue)',
                      color: 'var(--tgh-blue)',
                      fontSize: '1rem'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = 'var(--tgh-blue)';
                      e.target.style.color = '#fff';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                      e.target.style.color = 'var(--tgh-blue)';
                    }}
                  >
                    {ltr}
                  </button>
                ))}
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={() => handleLetterClick('#')}
                  style={{
                    width: '45px',
                    height: '45px',
                    borderRadius: '50%',
                    fontWeight: '600',
                    border: '2px solid var(--tgh-blue)',
                    color: 'var(--tgh-blue)',
                    fontSize: '1rem'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = 'var(--tgh-blue)';
                    e.target.style.color = '#fff';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = 'var(--tgh-blue)';
                  }}
                >
                  #
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5" style={{ backgroundColor: '#fff' }}>
        <div className="container">
          <div className="row g-4 mb-5 align-items-start">
            <div className="col-lg-8 mb-4">
              <div className="card border-0 shadow-sm" style={{ borderRadius: '8px', overflow: 'hidden' }}>
                <div className="row g-0" style={{ minHeight: '280px' }}>
                  <div className="col-md-6">
                    <div className="card-body p-4" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%', minHeight: '280px' }}>
                      <div className="mb-2" style={{ fontSize: '1.75rem' }}>
                        <i className="bi bi-journal-medical" style={{ color: 'var(--tgh-blue)' }}></i>
                      </div>
                      <h3 className="card-title mb-2" style={{ fontWeight: 'bold', fontSize: '1.25rem' }}>Diseases &amp; conditions</h3>
                      <p className="card-text text-muted mb-2" style={{ fontSize: '0.95rem', lineHeight: '1.5' }}>
                        In-depth articles on conditions, causes, and care.
                      </p>
                      <Link to="/diseases" className="text-decoration-none" style={{ color: 'var(--tgh-blue-light)', fontWeight: '600', fontSize: '0.95rem' }}>
                        Browse diseases <i className="bi bi-arrow-right ms-1"></i>
                      </Link>
                    </div>
                  </div>
                  <div className="col-md-6" style={{ display: 'flex', alignItems: 'stretch', height: '280px', overflow: 'hidden' }}>
                    <img
                      src="/img/carousel/admin2.jpg"
                      alt="Diseases and conditions"
                      className="img-fluid"
                      style={{ width: '100%', height: '280px', objectFit: 'cover', objectPosition: 'center', display: 'block' }}
                      onError={(e) => {
                        e.target.src = 'https://via.placeholder.com/600x400/003d82/ffffff?text=Diseases';
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="border-start ps-lg-4" style={{ borderColor: '#e0e0e0' }}>
                <h6 className="mb-2">TGH News</h6>
                <p className="text-muted small mb-3">
                  Latest news and updates from Tema General Hospital.
                </p>
                {newsLoading ? (
                  <div className="text-center py-2">
                    <div className="spinner-border spinner-border-sm text-primary" role="status" />
                    <div className="small text-muted mt-2">Loading news...</div>
                  </div>
                ) : tghNews.length === 0 ? (
                  <p className="text-muted small mb-0">No news articles available at this time.</p>
                ) : (
                  <ul className="list-unstyled small" style={{ maxHeight: '70vh', overflowY: 'auto', paddingRight: '0.25rem' }}>
                    {tghNews.map((post) => (
                      <li key={post.id} className="mb-3 pb-2" style={{ borderBottom: '1px solid #f0f0f0' }}>
                        <Link
                          to={`/news/${post.id}`}
                          style={{ color: 'var(--tgh-blue-light)', textDecoration: 'none', fontWeight: 600 }}
                        >
                          {post.title}
                        </Link>
                        {post.date && (
                          <div className="text-muted" style={{ fontSize: '0.75rem', marginTop: '0.15rem' }}>
                            {formatDate(post.date)}
                          </div>
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default SymptomsIndex;
